module.exports = __webpack_public_path__ + "img/web_icon_natural.144c7c48.png";